<template>
    <div class="col-12 xl:col-6 px-3 pb-3 pt-0 xl:p-4 bg-red-1001">
        <div class="w-full surface-0 border-round-xl xl:border-round-2xl lg:border-round-2xl">
            <div class="flex flex-column xl:flex-row xl:justify-content-between md:flex-row md:justify-content-between p-5 gap-5">
                <div class="flex flex-column flex-order-1 gap-3 xl:flex-order-0 md:flex-order-0 xl:gap-5">
                    <span class="text-4xl text-700 font-medium">{{ descHead }}</span>
                    <span class="text-600 text-left h-6rem line-height-1">{{ descBody }}</span>
                    
                    <Button :label="descButton" @click="onClick"
                        class="hidden md:flex xl:flex w-13rem justify-content-center"/>
                </div>
                <div class="flex-order-0 xl:flex-order-1 md:flex-order-1">
                    <img :src="imageUrl" alt="icon-about" />
                </div>
            </div>
        </div>
    </div>
    <AboutModal ref="openModal" :from="type" />
</template>

<script>
import AboutModal from "@/components/widgets/AboutModal.vue"
import Event from '@/assets/js/Event.js'

export default {
    props: ['imageUrl', 'descHead', 'descBody', 'descButton', 'descLink', 'imageLink', 'type'],
    computed: {
        isLoggedIn: function () { return this.$store.getters.isAuthenticated },
    },
    components: {
        AboutModal,
    },
    methods: {
        onClick() {
            if(!this.isLoggedIn) {
                this.$router.push('/auth/')
                return
            }
            switch (this.type) {
                case 'clients':
                    try { this.event.send('clientsClick') } catch {}
                    this.$router.push('/personal/transfer/create/')
                    break
                case 'partner':
                    try { this.event.send('partnerClick') } catch {}
                    this.$router.push('/personal/partner/')
                    break
                case 'merchant':
                    try { this.event.send('merchantClick') } catch {}
                    this.$router.push('/merchant/')
                    break
                case 'invest':
                    try { this.event.send('investClick') } catch {}
                    this.$refs.openModal.openModal()
                    break
                default:
                    break
            }
        },
    },
    beforeCreate() {
        this.event = new Event(this)
    },
};
</script>